// src/main.js
//
// PragyaAI Client — Phase 1 bootstrap.
// Uses the new domain-grouped store and unified auth guard.

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createI18n } from 'vue-i18n';
import messages from './common/messages.json';
import PrimeVue from 'primevue/config';
import { Tooltip } from 'primevue';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import { ensureAuthState } from '@/shared/auth/bootstrap';

import './common/global.css';
import 'primeicons/primeicons.css';
// import './assets/theme/default/global.scss';
//TODO: Uncomment once we have the global CSS fixed!

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en: messages },
});

const app = createApp(App);

app.use(PrimeVue, {
  theme: {
    preset: 'none',
    options: {
      prefix: 'p',
      darkModeSelector: '.dark',
      cssLayer: 'tailwind-base, primevue, tailwind-utilities',
    },
  },
});
app.use(ToastService);
app.component('Toast', Toast);
app.directive('tooltip', Tooltip);

console.log('CI-CD setup completed! v2');

app.use(store);
// Bootstrap auth: sync token and fetch role from server before first render
ensureAuthState(store).then(() => {
  app.use(router).use(i18n).mount('#app');
});
